/**
 * Web persistence adapter for user settings.
 * Uses localStorage as placeholder until user auth is implemented.
 * 
 * TODO: Replace with /users/me API endpoint (FastAPI users)
 */
import { ISettingsPersistence } from "@edgerunner/shared/main";
import { UserSettings, DEFAULT_USER_SETTINGS } from "@edgerunner/shared/main";

const STORAGE_KEY = 'edgerunner-user-settings';

export const webSettingsPersistence: ISettingsPersistence = {
    getPlatform: () => 'web',

    loadSettings: async (): Promise<UserSettings> => {
        try {
            const stored = localStorage.getItem(STORAGE_KEY);
            if (!stored) {
                return { ...DEFAULT_USER_SETTINGS };
            }
            const parsed = JSON.parse(stored) as Partial<UserSettings>;
            // Deep merge to preserve nested defaults
            return {
                ...DEFAULT_USER_SETTINGS,
                ...parsed,
                export_options: {
                    ...DEFAULT_USER_SETTINGS.export_options,
                    ...parsed.export_options,
                    config: {
                        ...DEFAULT_USER_SETTINGS.export_options.config,
                        ...parsed.export_options?.config,
                    },
                },
            };
        } catch (error) {
            console.error('webSettingsPersistence.loadSettings:', error);
            return { ...DEFAULT_USER_SETTINGS };
        }
    },

    writeSettings: async (partial: Partial<UserSettings>): Promise<UserSettings> => {
        const current = await webSettingsPersistence.loadSettings();
        const updated: UserSettings = {
            ...current,
            ...partial,
            export_options: partial.export_options
                ? {
                    ...current.export_options,
                    ...partial.export_options,
                    config: partial.export_options.config
                        ? { ...current.export_options.config, ...partial.export_options.config }
                        : current.export_options.config,
                }
                : current.export_options,
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
        return updated;
    },

    resetTopLevelSetting: async (key: keyof UserSettings): Promise<UserSettings> => {
        const current = await webSettingsPersistence.loadSettings();
        const updated: UserSettings = {
            ...current,
            [key]: DEFAULT_USER_SETTINGS[key],
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
        return updated;
    },
};
